var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C11.8326 16.5 11.6702 16.4694 11.5128 16.4084C11.3555 16.3473 11.2249 16.2659 11.1211 16.1641L5.34529 10.5458C5.1151 10.3219 5 10.0369 5 9.69084C5 9.34478 5.1151 9.05979 5.34529 8.83588C5.57549 8.61196 5.86846 8.5 6.22422 8.5C6.57997 8.5 6.87294 8.61196 7.10314 8.83588L12 13.5992L16.8969 8.83588C17.1271 8.61196 17.42 8.5 17.7758 8.5C18.1315 8.5 18.4245 8.61196 18.6547 8.83588C18.8849 9.05979 19 9.34478 19 9.69084C19 10.0369 18.8849 10.3219 18.6547 10.5458L12.8789 16.1641C12.7534 16.2862 12.6173 16.373 12.4709 16.4243C12.3244 16.4756 12.1674 16.5008 12 16.5Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f915f05c00e14ba8e220dabc1e01baa7.svg";
export { ForwardRef as ReactComponent };